<template>
    <div :class="from == 'comList' ? 'com_item2' : 'com_item'">
        <router-link
            :to="{ name: 'portalComInfo', query: { oid: item.oid } }"
            class="com_left"
        >
            <img class="com_logo" :src="item.logo_resize" />
            <div class="com_name_zhanwei">
                <div class="com_name two-ellipsis">
                    <img
                        src="https://res.to2025.com/assets/exih/img/tui.png"
                        class="recommend_icon"
                        v-if="item.recommended"
                    />
                    {{ item.company_name }}
                </div>
                <div class="zhanwei">
                    展位号：<span
                        v-for="(child, index) in item.buildingandposition"
                        :key="index"
                    >
                        <i v-if="index != 0">、</i>
                        {{ child }}
                    </span>
                </div>
            </div>
        </router-link>
        <div class="com_right">
            <router-link
                :to="{
                    name: 'portalProductInfo',
                    query: { oid: child.product_oid },
                }"
                class="pro_item"
                v-for="(child, index) in item.productInfo"
                :key="index"
            >
                <img
                    class="pro_logo"
                    :src="child.pic_url"
                    v-if="(child.pic_url || '') != ''"
                />
                <img
                    class="pro_logo"
                    v-else
                    src="https://tstres.to2025.com/assets/exih/img/malfunction.png"
                />

                <div class="pro_name">{{ child.core.product_name }}</div>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: "ComItem",
    props: ["item", "from"],
    data() {
        return {};
    },
    mounted() {},
};
</script>

<style lang="scss" scoped>
.com_item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 40px 0;

    .com_left {
        display: flex;
        justify-content: flex-start;
        .com_logo {
            width: 120px;
            height: 120px;
            border: 1px solid #cccccc;
            border-radius: 10px;
            margin-right: 40px;
        }
        .com_name_zhanwei {
            width: 400px;
            .com_name {
                font-size: 20px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #101010;
                line-height: 36px;
                font-weight: bold;

                .recommend_icon {
                    width: 76px;
                    height: 30px;
                    margin-right: 10px;
                }
            }
            .zhanwei {
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #7a7b7d;
                margin-top: 14px;
            }
        }
    }
    .com_right {
        display: flex;
        justify-content: flex-end;
        // align-items: center;
        .pro_item {
            margin-left: 40px;
            .pro_logo {
                width: 120px;
                height: 120px;
                border: 1px solid #cccccc;
                border-radius: 4px;
            }
            .pro_name {
                width: 120px;
                padding: 0 3px 0 7px;
                font-size: 14px;
                font-family: PingFang SC;
                color: #7a7b7d;
                margin-top: 11px;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
            }
        }
    }
}
.com_item2 {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 40px 0;

    .com_left {
        display: flex;
        justify-content: flex-start;
        .com_logo {
            width: 120px;
            height: 120px;
            border: 1px solid #cccccc;
            border-radius: 10px;
            margin-right: 35px;
        }
        .com_name_zhanwei {
            width: 240px;
            .com_name {
                font-size: 20px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #101010;
                line-height: 36px;
                font-weight: bold;

                .recommend_icon {
                    width: 76px;
                    height: 30px;
                    margin-right: 10px;
                }
            }
            .zhanwei {
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #7a7b7d;
                margin-top: 14px;
            }
        }
    }
    .com_right {
        display: flex;
        justify-content: flex-end;
        // align-items: center;
        .pro_item {
            margin-left: 36px;
            &:first-child {
                margin-left: 30px;
            }
            .pro_logo {
                width: 100px;
                height: 100px;
                border: 1px solid #cccccc;
                border-radius: 4px;
            }
            .pro_name {
                width: 100px;
                padding: 0 3px 0 7px;
                font-size: 14px;
                font-family: PingFang SC;
                color: #7a7b7d;
                margin-top: 11px;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ComItem.vue